import { render, staticRenderFns } from "./PsiAppLoader.vue?vue&type=template&id=91240a50&"
import script from "./PsiAppLoader.vue?vue&type=script&lang=js&"
export * from "./PsiAppLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VMain,VProgressCircular,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91240a50')) {
      api.createRecord('91240a50', component.options)
    } else {
      api.reload('91240a50', component.options)
    }
    module.hot.accept("./PsiAppLoader.vue?vue&type=template&id=91240a50&", function () {
      api.rerender('91240a50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/loaders/PsiAppLoader.vue"
export default component.exports